export default __webpack_public_path__ + "static/media/education.a8e13246.svg";